/**
 * Extracts query parameters from URL
 * @param {string} search - window.location.search or props.location.search
 * @returns {Object} Object containing query parameters
 */
export const getQueryParams = (search) => {
  const params = new URLSearchParams(search);
  const result = {};

  for (const [key, value] of params.entries()) {
    // Handle numeric values
    if (key === "appBrandId") {
      const numValue = parseInt(value, 10);
      result[key] = isNaN(numValue) ? null : numValue;
    } else {
      result[key] = value;
    }
  }

  return result;
};

/**
 * Validates appBrandId parameter
 * @param {number|string} appBrandId - The app brand ID to validate
 * @returns {number|null} Valid app brand ID or null
 */
export const validateAppBrandId = (appBrandId) => {
  if (appBrandId == null) return null;

  const numValue =
    typeof appBrandId === "string" ? parseInt(appBrandId, 10) : appBrandId;

  // Basic validation - positive integer
  return Number.isInteger(numValue) && numValue > 0 ? numValue : null;
};
